import React, { useState } from 'react';
import './DisplaySettings.css';
import { AppHeader, BottomNavigation, CreateOptionsMenu, BackButton } from './shared';
import { useLogout, useUserData } from '../hooks';
import { useNavigation } from '../contexts/NavigationContext';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';
import { AdBanner } from './ads';

/**
 * Issue #98: Display Settings Page
 * Allows users to switch between Light Mode and Dark Mode
 */
function DisplaySettings() {
  const navigation = useNavigation();
  const { userData } = useUserData();
  const { handleLogout, isLoggingOut, logoutError, clearLogoutError } = useLogout(navigation.onLogout);
  const { t } = useLanguage();
  const { theme, setTheme } = useTheme();
  const [showCreateOptions, setShowCreateOptions] = useState(false);

  const handleThemeChange = (newTheme) => {
    if (newTheme !== theme) {
      setTheme(newTheme);
    }
  };

  return (
    <div className="display-settings-page">
      {/* Header Navigation Bar - Using shared AppHeader component */}
      <AppHeader
        userData={userData}
        onLogout={handleLogout}
        isLoggingOut={isLoggingOut}
        logoutError={logoutError}
        onClearLogoutError={clearLogoutError}
      />

      {/* Tab Navigation */}
      <div className="tab-navigation-display">
        <span className="tab-title">{t('displaySettings.title')}</span>
      </div>

      {/* Display Settings Content */}
      <main className="display-settings-content">
        {/* Back Button */}
        <BackButton
          onClick={navigation.onNavigateBack}
          className="display-back-button"
        />

        {/* Title */}
        <div className="display-title">
          <span>{t('displaySettings.setPreferred')}</span>
        </div>

        {/* Display Options */}
        <div className="display-options">
          <label className="display-option">
            <input
              type="radio"
              name="displayMode"
              value="light"
              checked={theme === 'light'}
              onChange={() => handleThemeChange('light')}
            />
            <span className="display-radio-custom"></span>
            <span className="display-label">{t('displaySettings.lightMode')}</span>
          </label>

          <label className="display-option">
            <input
              type="radio"
              name="displayMode"
              value="dark"
              checked={theme === 'dark'}
              onChange={() => handleThemeChange('dark')}
            />
            <span className="display-radio-custom"></span>
            <span className="display-label">{t('displaySettings.darkMode')}</span>
          </label>
        </div>

      </main>

      {/* Issue #204: Ad Banner */}
      <AdBanner slot="settings-bottom" />

      {/* Bottom Navigation Bar - Using shared component */}
      <BottomNavigation
        activeTab="profile"
        onCreateClick={() => setShowCreateOptions(!showCreateOptions)}
      />

      {/* Create Options Menu - Using shared component */}
      <CreateOptionsMenu
        isOpen={showCreateOptions}
        onClose={() => setShowCreateOptions(false)}
      />
    </div>
  );
}

export default DisplaySettings;
